module.exports = __webpack_public_path__ + "media/application/images/svgs/compass-1961413cfe556d2e8c8e988cc0d51f33.svg";